import {nanoid} from 'nanoid';
import type {Point} from './abstract-units';
import type {BoxEdges} from './edge';
import type {Wireframe} from './wireframe';
import type {Widget} from './widget/widget';

export type CellId = string;

export function getNewCellId(): CellId {
    return nanoid();
}

export interface Cell {
    id: CellId;
    edges: BoxEdges;
    widgets: Widget[];
    activeWidget: Widget;
    display: CellDisplayInfo;
}

export interface CellDisplayInfo {
    pos: Point; // Top-Left point.
    nextPos: Point; // Top-Left point of the next cell lied by diagonal (bottom-right + 1).
    size: Point;
    wireframe: Wireframe;
    cellComponent?: any; // The cell presentation component. Is managed by the component itself.
}
